export default __webpack_public_path__ + "static/1780-239f33aaca075238ef3a2d4665e30b68.gif";